import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { faRepeat } from '@fortawesome/pro-light-svg-icons/faRepeat';
import clsx from 'clsx';
import { useRecurrenceDescription } from 'src/modules/contentList/hooks/useRecurrenceDescription';
import { Icon } from 'src/shared/components/icon';
export function RecurrenceDescription({ module, className }) {
    const description = useRecurrenceDescription(module);
    return (_jsxs("div", { className: clsx('flex items-center gap-1 overflow-hidden text-extrasmall font-regular text-neutral-500', className), children: [_jsx(Icon, { icon: faRepeat }), _jsx("p", { className: "truncate", title: description, children: description })] }));
}
export default RecurrenceDescription;
